import DashboardHeader from './common/dashboardHeader.js';
import DashboardAdthriveContent from './dashboardAdthriveContent.js';
import {Grid} from '@material-ui/core';
import {useSelector} from 'react-redux';


function DashboardAdthrive(props){
    const currentPage = useSelector(state => state.currentPage);

    let showDashboard = !currentPage.shouldTryAutoloading; // hide flash of dashboard on first load
    showDashboard = (!showDashboard && currentPage.postId) ? false : true; 
    return(
        <Grid container xs="12" md="12" direction="row" style={{opacity: showDashboard ? '1' : '0'}}>
            <DashboardHeader Briefs={props.Briefs}/>
            <DashboardAdthriveContent Briefs={props.Briefs}/>
        </Grid>
    );

}

export default DashboardAdthrive;